<template>
  <div>
    <h4 class="text-right text--black experiment--padding">
      {{ new Date(experiment.created_at).toLocaleString()}}
    </h4>
    <span class="experiment__line"></span>
    <div class="d-flex flex-column flex-sm-row
      justify-content-between align-content-center experiment--padding mt-1">
      <h4 class=" text-center text-sm-left text--black align-self-center">
        {{ $t("experiment") }}: {{experiment.title}}
      </h4>
      <div v-if="experiment.has_results && !previewMode"
        class="d-flex flex-column flex-lg-row">
        <router-link :to="{ path: `/results/show/${experiment.id}` }" tag="button"
          class="btn btn-primary btn-sm mt-3 mt-lg-0 mr-lg-3" v-scroll-to="'#scrollToOnLoad'">
          {{ $t("show") }}
        </router-link>
        <router-link :to="{ path: `/results/${experiment.id}` }"
          tag="button" class="btn btn-primary btn-sm mt-3 mt-lg-0 mr-lg-3"
          v-scroll-to="'#scrollToOnLoad'">
          {{ $t("edit") }}
        </router-link>
        <b-btn variant="primary" size="sm" class="mt-3 mt-lg-0" @click="showProtocol(experiment)">
          {{ $t("protocol") }}
        </b-btn>
      </div>
      <div v-else-if="experiment.has_results">
        <router-link :to="{ path: `/results/show/${experiment.id}`}"
          tag="button"
          class="btn btn-primary btn-sm mt-3 mt-lg-0 mr-lg-3" v-scroll-to="'#scrollToOnLoad'">
          {{ $t("show") }}
        </router-link>
      </div>
      <div v-else-if="!experiment.has_results"
        class="experiment__options d-flex flex-column flex-lg-row">
        <b-btn variant="primary" size="sm" class="mr-lg-3 mt-2 mt-sm-0"
        @click="checkProtocol(experiment)">
          {{ $t("addresults") }}
        </b-btn>
        <span v-if="error" class="experiment__error">
          Upss.. {{ $t("protocolAlert") }}
        </span>
        <router-link :to="{ path: `/building_blocks/edit/${experiment.id}`}"
          tag="button"
          class="btn btn-primary btn-sm mt-3 mt-lg-0 mr-lg-3" v-scroll-to="'#scrollToOnLoad'">
          {{ $t("edit") }}
        </router-link>
        <b-btn variant="primary" size="sm" class="mt-3 mt-lg-0" @click="getProtocol(experiment.id)">
          {{ experiment.protocol || protocolGenerated ? 'Get Protocol' : $t("generateProtocol") }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import game from '@/api/v1/game';
import auth from '@/api/v1/auth';
import downloadFile from '@/utils/downloadFile';

export default {
  props: ['experiment', 'previewMode'],
  data() {
    return {
      isStudent: auth.user.isStudent,
      error: false,
      protocolGenerated: false,
    };
  },
  methods: {
    getProtocol(id) {
      const succ = (response) => {
        downloadFile(
          process.env.SERVER_URL + response.data.experiment.protocol,
          'protocol.pdf',
        );
        this.protocolGenerated = true;
      };
      this.error = false;
      game.getProtocol(id, succ);
    },
    checkProtocol(experiment) {
      if (experiment.protocol || this.protocolGenerated) {
        this.error = false;
        this.$router.push({ path: `/results/${experiment.id}` });
      } else {
        this.error = true;
      }
    },
    showProtocol(experiment) {
      downloadFile(
        process.env.SERVER_URL + experiment.protocol,
        'protocol.pdf',
      );
    },
    downloadFile,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";
@import "../styles/helpers/_include-media.scss";

.experiment {
  &__line {
    border-bottom: 3px solid $color--white-3;
    display: block;
  }
  &--padding {
    padding: 20px 50px;
    @include media("<sm") {
      padding: 20px 10px;
    }
  }
  &__options {
    position: relative;
  }
  &__error {
    color: black;
    position: absolute;
    bottom: -32px;
    left: -20px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListOfExperiments.vue